import React from 'react';
import { HeroFadeIn } from '../HeroFadeIn';
import { TiltCard } from '../TiltCard';

const LoginScreen = ({ onSignIn }) => (
  <div className="flex items-center justify-center h-screen">
    <div className="text-center">
      <HeroFadeIn delay={0.1}>
        <h1 className="text-3xl font-bold mb-8">UrbanTech Order Management</h1>
      </HeroFadeIn>
      <HeroFadeIn delay={0.3}>
        <TiltCard>
          <button
            onClick={onSignIn}
            className="bg-black text-white px-6 py-3 rounded-lg hover:bg-gray-800 transition-colors"
          >
            Sign In with Microsoft
          </button>
        </TiltCard>
      </HeroFadeIn>
    </div>
  </div>
);

export default LoginScreen;
